export default __webpack_public_path__ + "static/header.whw-46d1abf6d077251f2316abaa5a594f64.png";